import { Route, Routes } from "react-router-dom";
import WhatsAppButton from "./components/WhatsAppButton";

import AboutLKCTC from "./pages/About/AboutLKCTC";
import AcademicCalender from "./pages/Academics/AcademicCalendar";
import AdmissionForm from "./pages/Admission/AdmissionForm";
import AffiliationOrder from "./pages/MandatoryDisclosure/AffiliationOrder/index.jsx";
import AllEvents from "./pages/StudentsGallery/AllEvents";
import AllNoticeBoard from "./pages/Academics/AllNoticeBoard";
import AlumniMeet from "./pages/Alumni/AlumniMeet";
import AlumniTestimonials from "./pages/Alumni/AlumniTestimonials";
import Approval from "./pages/MandatoryDisclosure/Approval/index";
import BrandAmbassadors from "./pages/Alumni/BrandAmbassadors";
import CampusTour from "./pages/MandatoryDisclosure/CampusTour/index.jsx";
import CapacityAndCarrierBuilding from "./pages/About/CapacityCarrierBuilding";
import CompensatoryClasses from "./pages/Academics/CompensatoryClasses/index.jsx";
import Contact from "./pages/Contact";
import CoreValues from "./pages/About/CoreValues";
import CoursesOffered from "./pages/Admission/CoursesOffered";
import DepartmentOfAppliedScience from "./pages/Academics/DepartmentOfAppliedScience";
import DepartmentOfCivilEngineering from "./pages/Academics/DepartmentOfCivilEngineering";
import DepartmentOfComputerScience from "./pages/Academics/DepartmentOfComputerScience";
import DepartmentOfECE from "./pages/Academics/DepartmentOfECE";
import DepartmentOfHealthScience from "./pages/Academics/DepartmentOfHealthScience";
import DepartmentOfHotelManagement from "./pages/Academics/DepartmentOfHotelManagement";
import DepartmentOfIT from "./pages/Academics/DepartmentOfIT";
import EResources from "./pages/Academics/EResources";
import Examination from "./pages/Examination";
import FAQs from "./pages//Admission/FAQs";
import Faculty from "./pages/Academics/Faculty";
import FacultyDevelopmentProgramme from "./pages/FDP2025/index.jsx";
import Footer from "../src/components/Footer/index";
import FromTheDeskOf from "./pages/About/FromTheDeskOf";
import Header from "../src/components/Header/index";
import Home from "./pages/Home/index";
import IQAC from "./pages/NAAC/IQAC";
import IndustrialVisit from "./pages/Placements/industrial-visit";
import IndustryMOUs from "./pages/About/IndustryMOUs";
import IndustryPartners from "./pages/Placements/industry-partners";
import ListOfCourses from "./pages/Academics/ListOfCourses";
import ManagementDepartment from "./pages/Academics/ManagementDepartment";
import NCCWing from "./pages/NCCWing";
import Naactest2 from "./pages/NAAC/Naactest2";
import NewsGallery from "./pages/StudentsGallery/NewsGallery";
import NewsLetter from "./pages/NewsLetters/index.jsx";
import NotFoundPage from "./pages/404";
import OurGoverningBody from "./pages/About/ourGoverningBody";
import PageUnderConstruction from "./pages/PageUnderContruction";
import PhotoGallery from "./pages/PhotoGallery";
import PlacedListStudents from "./pages/Placements/student-placed-list";
import PlacementCell from "./pages/Placements/PlacementCell";
import PrivacyPolicy from "./pages/About/PrivacyPolicy/index.jsx";
import Prospectus from "./pages/Admission/Prospectus";
import ResearchInvation from "./pages/Academics/ResearchInvation";
import SSR from "./pages/NAAC/SSR";
import SWA from "./pages/SWA";
import SchoolOfMechanicalEngineering from "./pages/Academics/SchoolOfMechanicalEngineering";
import ScrollToHeading from "./components/ScrollToHeading";
import StudentMentoring from "./pages/StudentMentoring/index.jsx";
import UpcomingPlacements from "./pages/Placements/Upcoming-Placements";
import VisionAndMission from "./pages/About/Vision-Mission";
import WomenGrievance from "./pages/MandatoryDisclosure/WomenGrievance/index";

function App() {
  return (
    <ScrollToHeading offset={140}>
      <div className="">
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          {/* ________About______________ */}
          <Route path="/About/AboutLKCTC" element={<AboutLKCTC />} />
          <Route path="/About/CoreValues" element={<CoreValues />} />
          <Route path="/About/Vision-Mission" element={<VisionAndMission />} />
          <Route
            path="/About/ourGoverningBody"
            element={<OurGoverningBody />}
          />
          <Route path="/About/IndustryMOUs" element={<IndustryMOUs />} />
          <Route
            path="/About/CapacityCarrierBuilding"
            element={<CapacityAndCarrierBuilding />}
          />
          <Route path="/About/FromTheDeskOf" element={<FromTheDeskOf />} />
          <Route path="/About/PrivacyPolicy" element={<PrivacyPolicy />} />

          {/* _______________________________ */}

          {/* _______________Academics______________ */}
          <Route path="/Academics/ListOfCourses" element={<ListOfCourses />} />
          <Route path="/Academics/EResources" element={<EResources />} />
          <Route
            path="Academics/CompensatoryClasses"
            element={<CompensatoryClasses />}
          />

          <Route path="Academics/examination" element={<Examination />} />
          <Route
            path="/Academics/ResearchInvation"
            element={<ResearchInvation />}
          />
          <Route path="/Academics/Faculty" element={<Faculty />} />
          <Route
            path="/Academics/AllNoticeBoard"
            element={<AllNoticeBoard />}
          />
          <Route
            path="/Academics/AllNoticeBoard/:id"
            element={<AllNoticeBoard />}
          />
          <Route
            path="/Academics/ManagementDepartment"
            element={<ManagementDepartment />}
          />
          <Route
            path="/Academics/DepartmentOfIT"
            element={<DepartmentOfIT />}
          />
          <Route
            path="/Academics/DepartmentOfHotelManagement"
            element={<DepartmentOfHotelManagement />}
          />
          <Route
            path="/Academics/DepartmentOfAppliedScience"
            element={<DepartmentOfAppliedScience />}
          />
          <Route
            path="/Academics/DepartmentOfComputerScience"
            element={<DepartmentOfComputerScience />}
          />
          <Route
            path="/Academics/DepartmentOfCivilEngineering"
            element={<DepartmentOfCivilEngineering />}
          />
          <Route
            path="/Academics/DepartmentOfECE"
            element={<DepartmentOfECE />}
          />
          <Route
            path="/Academics/AcademicCalendar"
            element={<AcademicCalender />}
          />
          <Route
            path="/Academics/SchoolOfMechanicalEngineering"
            element={<SchoolOfMechanicalEngineering />}
          />
          <Route
            path="/Academics/DepartmentOfHealthScience"
            element={<DepartmentOfHealthScience />}
          />
          {/* ___________Admissions______________ */}
          <Route path="/Admission/AdmissionForm" element={<AdmissionForm />} />
          <Route path="/Admission/Prospectus" element={<Prospectus />} />
          <Route
            path="/Admission/CoursesOffered"
            element={<CoursesOffered />}
          />
          <Route path="/Admission/FAQs" element={<FAQs />} />
          {/* ____________________________________ */}

          {/* ___________Placements______________ */}

          <Route path="/Placements/PlacementCell" element={<PlacementCell />} />
          <Route
            path="/Placements/industry-partners"
            element={<IndustryPartners />}
          />
          <Route
            path="/Placements/industrial-visit"
            element={<IndustrialVisit />}
          />
          <Route
            path="/Placements/student-placed-list"
            element={<PlacedListStudents />}
          />
          <Route
            path="/Placements/Upcoming-Placements"
            element={<UpcomingPlacements />}
          />

          {/* ___________Students Gallery______________ */}

          <Route
            path="/StudentsGallery/NewsGallery"
            element={<NewsGallery />}
          />
          <Route path="/StudentsGallery/AllEvents" element={<AllEvents />} />
          <Route path="/StudentsGallery/swa" element={<SWA />} />
          <Route path="/StudentsGallery/newsletters" element={<NewsLetter />} />

          <Route path="/StudentsGallery/nccWing" element={<NCCWing />} />
          <Route path="/StudentsGallery/Nacctest2" element={<Naactest2 />} />
          <Route path="/StudentsGallery/SSR" element={<SSR />} />
          <Route path="/StudentsGallery/IQAC" element={<IQAC />} />

          {/* ___________Alumni______________ */}
          <Route
            path="/Alumni/BrandAmbassadors"
            element={<BrandAmbassadors />}
          />
          <Route
            path="/Alumni/AlumniTestimonials"
            element={<AlumniTestimonials />}
          />
          <Route path="/Alumni/AlumniMeet" element={<AlumniMeet />} />

          {/* ___________Contact______________ */}
          <Route path="/Contact" element={<Contact />} />

          {/* ___________Mandatory Disclosure______________ */}
          <Route path="/campus-tour" element={<CampusTour />} />

          <Route
            path="/MandatoryDisclosure/AffiliationOrder"
            element={<AffiliationOrder />}
          />
          <Route path="/MandatoryDisclosure/Approval" element={<Approval />} />
          <Route
            path="/MandatoryDisclosure/WomenGrievance"
            element={<WomenGrievance />}
          />

          <Route path="/student-mentoring" element={<StudentMentoring />} />

          <Route path="/fdp2025" element={<FacultyDevelopmentProgramme />} />

          {/* ___________gallery______________ */}
          <Route path="/PhotoGallery" element={<PhotoGallery />} />

          {/* _______________ERROR________________ */}
          <Route path="*" element={<NotFoundPage />} />

          {/* _______________Page Under Construction________________ */}
          <Route
            path="/pageUnderConstruction"
            element={<PageUnderConstruction />}
          />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </div>
    </ScrollToHeading>
  );
}

export default App;
